import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Modal } from '../../root/components/common'

const useStyles = makeStyles(() => ({
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 12
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 20
    }
}))

export const LocationSettingsOverrideMoveConfirmationModal = ({
    open,
    onConfirm,
    onCancel,
    locale
}) => {
    const classes = useStyles()

    return (
        <Modal size="md" open={open} onClose={onCancel}>
            <div className={classes.title}>
                {locale.devices.locationSettingsOverrideMoveWarningTitle}
            </div>
            <div>{locale.devices.locationSettingsOverrideMoveWarningText}</div>
            <div className={classes.buttons}>
                <Button reverted onClick={onCancel}>
                    {locale.common.cancel}
                </Button>
                <Button style={{ marginLeft: 8 }} onClick={onConfirm}>
                    {locale.devices.locationSettingsOverrideMoveConfirm}
                </Button>
            </div>
        </Modal>
    )
}
